<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog :close-on-click-modal="false" title="编辑付款" :show-close="true" :visible="true"
    :before-close="handleBeforeClose" width="725px">
    <div class="dialog__container">
      <el-form inline ref="form" class="search-form" label-position="right" :model="form" :rules="rules"
        label-width="100px">
        <el-form-item label="付款单据号:" prop="payableNo" class="input-with-col2 mr0">
          <el-input size="mini" disabled v-model.trim="form.payableNo" placeholder="系统自动生成" clearable></el-input>
        </el-form-item>
        <el-form-item label="单据日期:" prop="billDate" class="input-with-col2 mr0">
          <el-date-picker v-model="form.billDate" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            unlink-panels clearable></el-date-picker>
        </el-form-item>
        <el-form-item label="付款金额:" prop="money" class="input-with-col2 mr0">
          <el-input size="mini" type="number" v-model.trim="form.money" placeholder="请输入付款金额" clearable></el-input>
        </el-form-item>

        <el-form-item label="支付方式:" prop="card" class="input-with-col2 mr0">
          <el-select size="mini" v-model="form.card" filterable placeholder="请选择支付方式" clearable value-key="id">
            <el-option v-for="item in cardList" :key="item.id" :label="item.cardCode + '--'+ item.cardName"
              :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支出项:" prop="spending" class="input-with-col2 mr0">
          <el-select size="mini" v-model="form.spending" filterable placeholder="请选择支出项" clearable
            @change="spendingChange" value-key="code">
            <el-option v-for="item in spendingList" :key="item.code" :label="item.name" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="相关车辆:" prop="carInfo" class="input-with-col2 mr0" v-if="showCar"
          :rules="[{ required: true, message: '请选择车辆信息', trigger: 'blur' }]">
          <el-select size="mini" v-model="form.carInfo" filterable placeholder="请选择支出项" clearable value-key="id">
            <el-option v-for="item in carList" :key="item.id" :label="item.car" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="付款人:" prop="user" class="input-with-col2 mr0" v-if="showUser">
          <el-select size="mini" v-model="form.user" filterable placeholder="请选择付款人" clearable value-key="userId">
            <el-option v-for="item in userList" :key="item.userId" :label="item.nickname" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户:" prop="propertyUnit" class="input-with-col2 mr0" v-if="showProperty">
          <el-select size="mini" v-model="form.propertyUnit" filterable placeholder="请选择客户" clearable value-key="id">
            <el-option v-for="item in propertyUnitSimpleList" :key="item.id" :label="item.unitName"
              :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称:" prop="content" class="input-with-col2 mr0" v-if="showContent">
          <el-input size="mini" v-model.trim="form.content" placeholder="请输入名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="remark" class="input-with-col2 mr0">
          <el-input size="mini" v-model.trim="form.remark" placeholder="请输入备注" clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" type="primary" size="mini" :loading="loadBtn" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {
    savePayable,
    userSimpleList
  } from '@/api/Payable'
  import {
    getCardList
  } from '@/api/Card'
  import {
    getCarList
  } from '@/api/Car'
  import {
    getSpendingList
  } from '@/api/Spending'
  import {
    getPropertyUnitSimpleList
  } from '@/api/Receive'
  import cookies from '../../../libs/util.cookies'
  import {
    Form
  } from 'element-ui'
  export default {
    data() {
      return {
        spendingList: [],
        propertyUnitSimpleList: [],
        userList: [],
        cardList: [],
        carList: [],
        form: {
          spending: {},
          carInfo: {},
          card: {},
          user: {},
          billDate: '',
          money: '',
          remark: ''
        },
        rules: {
          billDate: [{
            required: true,
            message: "请选择支出项",
            trigger: "blur",
          }, ],
          spending: [{
            required: true,
            message: "请选择支出项",
            trigger: "blur",
          }, ],
          money: [{
            required: true,
            message: "请输入金额",
            trigger: "blur",
          }, ],
          user: [{
            required: true,
            message: '请选择付款人信息',
            trigger: 'blur'
          }],
          carInfo: [{
            required: true,
            message: '请选择车辆信息',
            trigger: 'blur'
          }],
          card: [{
            required: true,
            message: "请选择支付方式",
            trigger: "blur",
          }, ]
        },
        showCar: false,
        showUser: false,
        showProperty: false,
        showContent: false,
        carCodeArr: [
          "0101", "0102", "0116", "0112"
        ],
        userCodeArr: [
          "0101", "0102", "0104", "0105", "0106", "0107", "0110", "0111",
          "0112", "0113", "0114", "0115", "0116", "0117", "0118", "0119", "0120", "0121"
        ],
        propertyCodeArr: [
          "0113", "0114", "0121","0126"
        ],
        contentCodeArr: [
          "0102", "0106", "0107", "0111", "0113", "0114"
        ],
        loadBtn: false,
      };
    },
    props: {
      detail: {
        required: true,
        type: Object
      }
    },
    created() {
      this.form = {
        ...this.detail
      }
      this.form.spending = {
        code: this.form.type,
        name: this.form.typeName
      };
      this.form.card = {
        id: this.form.cardId,
        cardCode: this.form.cardCode,
      };
      this.form.carInfo = {
        id: this.form.carId,
        car: this.form.carCode,
      };
      this.form.user = {
        userId: this.form.payUserId,
        nickname: this.form.payUserName,
      };
      if (this.carCodeArr.includes(this.form.type)) {
        this.showCar = true;
      } else if (this.userCodeArr.includes(this.form.type)) {
        this.showUser = true;
      }
      this.handleSpendingList();
      this.handleUserSimpleList();
      this.handleCarList();
      this.handleCardList();
      this.handlePropertyUnitSimpleList();
    },
    methods: {
      async handlePropertyUnitSimpleList() {
        const res = await getPropertyUnitSimpleList({});
        if (res.code === 200) {
          this.propertyUnitSimpleList = res.data
        }
      },
     spendingChange(item) {
       this.showCar = false;
       this.showUser = false;
       if (this.carCodeArr.includes(item.code)) {
         this.showCar = true;
       }
       if (this.userCodeArr.includes(item.code)) {
         this.showUser = true;
       }
       if (this.propertyCodeArr.includes(item.code)) {
         this.showProperty = true;
       }
       if (this.contentCodeArr.includes(item.code)) {
         this.showContent = true;
       }
     },
      async handleCardList() {
        const res = await getCardList({});
        if (res.code === 200) {
          this.total = res.data.total
          this.cardList = res.data
        }
      },
      async handleCarList() {
        const res = await getCarList({});
        if (res.code === 200) {
          this.total = res.data.total
          this.carList = res.data
        }
      },
      async handleUserSimpleList() {
        const res = await userSimpleList({});
        if (res.code === 200) {
          this.total = res.data.total
          this.userList = res.data
        }
      },
      async handleSpendingList() {
        const res = await getSpendingList();
        if (res.code === 200) {
          this.total = res.data.total
          this.spendingList = res.data
        }
      },
      inArray(needle, array) {
        for (var i = 0; i < array.length; i++) {
          if (needle === array[i]) {
            return true;
          }
        }
        return false;
      },
      handleBeforeClose(done) {
        this.$emit("cancel");
        done();
      },
      handleCancel() {
        this.$emit("cancel");
      },
      async handleConfirm() {
        console.log(this.form)
        if (this.loadBtn) return;
        this.$refs["form"].validate(async (valid) => {
          if (valid) {
            this.loadBtn = true;
            const params = {
              ...this.form
            }
            console.log(params)
            params.type = params.spending.code;
            params.typeName = params.spending.name;
            params.cardId = params.card.id;
            params.cardCode = params.card.cardCode;
            if (this.carCodeArr.includes(params.type) && params.carInfo) {
              params.carId = params.carInfo.id;
              params.carCode = params.carInfo.car;
            } else {
              params.carId = null;
              params.carCode = null;
            }
            if (this.userCodeArr.includes(params.type) && params.user) {
              params.payUserId = params.user.userId;
              params.payUserName = params.user.nickname;
            } else {
              params.payUserId = null;
              params.payUserName = null;
            }
            if (this.propertyCodeArr.includes(params.type) && params.propertyUnit) {
              params.propertyUnitId = params.propertyUnit.id;
              params.propertyUnitName = params.propertyUnit.unitName;
            } else {
              params.propertyUnitId = null;
              params.propertyUnitName = null;
            }
            if (this.contentCodeArr.includes(params.type)) {
              params.content = params.content;
            } else {
              params.content = null;
            }
            delete params.carInfo;
            delete params.user;
            delete params.card;
            delete params.spending;
            console.log(params)
            const res = await savePayable(params);
            if (res.code === 200) {
              this.$message.success("添加成功");
              this.$emit("confirm");
            }
            this.loadBtn = false;
          }
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/PayableManagement/components/EditCause.vue